import { Location } from "react-router-dom";

export const getQueryParams = (location:Location) => {
    return new URLSearchParams(location.search);
  };